import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ReactExport from "react-export-excel";
import { Grid, Card } from '@material-ui/core';
import { Row, Col, Typography, Upload, notification, Icon, Button } from 'antd';
import MainContainer from '../../../components/MainContainer';
import ApiCaller from '../../../utils/api-caller';
import { DownloadOutlined } from '@ant-design/icons';

import './importItemLanguage.css';

const { Text } = Typography;
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

@inject(
    'loginStore',
    'importItemLanguageStore'
)
@observer
class ImportItemLanguagePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadingFileState: false,
            uploadingCategoryFileState: false,
            uploadingSubCategoryAndItemFileState: false
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
        
        this.props.importItemLanguageStore.initImportItemLanguage();
    }

    // ON CHANGE

    categoryOnChange = (value) => {
        this.props.importItemLanguageStore.setCategoryId(value);
    }

    // ON UPLOAD

    dummySubCategoryAndItemRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    beforeUploadSubCategoryAndItem = (file) => {
        const isCsv = file.type === 'application/vnd.ms-excel' || file.type === 'text/csv';
        if (!isCsv) {
            notification.warning({
                message: `Failed to upload file`,
                description:
                    'You can only upload CSV file!',
                placement: 'bottomRight',
            });
        }

        const isLessThan10Mb = file.size / 1024 / 1024 < 2;
        if (!isLessThan10Mb) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'Image must smaller than 2MB!',
                placement: 'bottomRight',
            });
        }

        if (isCsv && isLessThan10Mb) {
            this.setState({ uploadingSubCategoryAndItemFileState: true });
        }

        return isCsv && isLessThan10Mb;
    }

    uploadSubCategoryAndItemOnChange = (info) => {
        if (info.file.status) {
            if (info.file.status === 'uploading') {
                return;
            }

            if (info.file.status === 'done') {
                const cmsUsername = window.localStorage.getItem('adminLoginName')?.replace(/(^['"]|['"]$)/g, '');
                ApiCaller.Csvs.apiUploadCsvSubCategoryAndItemNames(info.file.originFileObj, cmsUsername).then(uploadCsvSubCategoryAndItemNameResponses => {
                    if (uploadCsvSubCategoryAndItemNameResponses) {
                        if (uploadCsvSubCategoryAndItemNameResponses.length === 0) {
                            notification.success({
                                message: `Success`,
                                description:
                                    'Sub Category and Item Names has been successfully imported.',
                                placement: 'topRight',
                            });
                        } else {
                            notification.success({
                                message: `Error`,
                                description:
                                    `Failed to import Sub Category and Item Names. Error Messages = ${uploadCsvSubCategoryAndItemNameResponses[0].errorMessage}`,
                                placement: 'topRight',
                            });
                        }
                    } else {
                        notification.success({
                            message: `Error`,
                            description:
                                `Failed to import Sub Category and Item Names. Error Messages = ${uploadCsvSubCategoryAndItemNameResponses[0].errorMessage}`,
                            placement: 'topRight',
                        });
                    }
                    this.setState({ uploadingSubCategoryAndItemFileState: false });
                })
            }
        }
    }

    exportMenusOnClick = () => {
        ApiCaller.Exports.TaskMenus().then((response) => {
            this.setState({ exportMenusDataSet: response ? response : [] });
            this.setState({ exportingMenu: false }); // Add this line in case user download export items multiple times
            this.setState({ exportingMenu: true });
        });
    }

    exportCategoriesOnClick = () => {
        ApiCaller.Exports.TaskCategories().then((response) => {
            this.setState({ exportCategoriesDataSet: response ? response : [] });
            this.setState({ exportingCategories: false }); // Add this line in case user download export items multiple times
            this.setState({ exportingCategories: true });
        });
    }

    exportSubCategoriesOnClick = () => {
        ApiCaller.Exports.TaskSubCategories().then((response) => {
            this.setState({ exportSubCategoriesDataSet: response ? response : [] });
            this.setState({ exportingSubCategories: false }); // Add this line in case user download export items multiple times
            this.setState({ exportingSubCategories: true });
        });
    }

    exportFnbOnClick = () => {
        ApiCaller.Exports.TaskItemFnbs().then((response) => {
            this.setState({ exportFnbDataSet: response ? response : [] });
            this.setState({ exportingFnb: false }); // Add this line in case user download export items multiple times
            this.setState({ exportingFnb: true });
        });
    }

    exportNonFnbOnClick = () => {
        ApiCaller.Exports.TaskItemNonFnbs().then((response) => {
            this.setState({ exportNonFnbDataSet: response ? response : [] });
            this.setState({ exportingNonFnb: false }); // Add this line in case user download export items multiple times
            this.setState({ exportingNonFnb: true });
        });
    }

    render() {
        const uploadSubCategoryAndItemButton = (
            <div>
                {
                    this.state.uploadingSubCategoryAndItemFileState
                        ?
                        <React.Fragment>
                            <Icon className='importItemLanguage-icon-upload' type='loading' />
                            <div className='importItemLanguage-div-upload'>Importing Bulk Items (Category, Sub Category and Item) ......</div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <Icon className='importItemLanguage-icon-upload' type='plus' />
                            <div className='importItemLanguage-div-upload'>Import Bulk Items (Category, Sub Category and Item)</div>
                        </React.Fragment>
                }
            </div>
        );

        return (
            <MainContainer title='Items Import' menukey='importitems'>
                <Grid container spacing={2} style={{ marginBottom: 20 }}>
                    <Grid item xs={12}>
                        <Card>
                            <Row className='importItemLanguage-row-container'>
                                <Col span={24} className='importItemLanguage-col-label'>
                                    <Text className='importItemLanguage-text-label'>Import Bulk Items (Category, Sub Category and Item)</Text><br />
                                    <Text className='importItemLanguage-text-label-detail'>Your file must be csv</Text>
                                </Col>
                                <Col span={24} className='importItemLanguage-col-input'>
                                    <Upload
                                        listType='picture-card'
                                        className='avatar-uploader'
                                        showUploadList={false}
                                        customRequest={this.dummySubCategoryAndItemRequest}
                                        beforeUpload={this.beforeUploadSubCategoryAndItem}
                                        onChange={(info) => this.uploadSubCategoryAndItemOnChange(info)}
                                    >
                                        {uploadSubCategoryAndItemButton}
                                    </Upload>
                                </Col>
                            </Row>
                        </Card>

                        <Card style={{ marginTop: "2em" }}>
                            <Row className='importItemLanguage-row-container'>
                                <Col span={24} className='importItemLanguage-col-label'>
                                    <Text className='importItemLanguage-text-label'>Export Menus</Text><br />
                                </Col>
                                <Col span={24}>
                                    <Button onClick={() => this.exportMenusOnClick()} type="primary"><DownloadOutlined />Download</Button>
                                    {(!this.state.exportingMenu) ? '' :
                                        <ExcelFile filename="Menu" hideElement={true}>
                                            <ExcelSheet data={this.state.exportMenusDataSet} name="Menu">
                                                <ExcelColumn label="Slug Name" value="slugName" />
                                                <ExcelColumn label="Parent Slug Name" value="parentSlugName" />
                                                <ExcelColumn label="Is Sub Category" value="isSubCategory" />
                                                <ExcelColumn label="Total" value="total" />
                                                <ExcelColumn label="Request Limit" value="requestLimit" />
                                                <ExcelColumn label="Price" value="price" />
                                                <ExcelColumn label="Name (English)" value="nameEnglish" />
                                                <ExcelColumn label="Name (Simplified Chinese)" value="nameSimplifiedChinese" />
                                                <ExcelColumn label="Name (Traditional Chinese)" value="nameTraditionalChinese" />
                                                <ExcelColumn label="Name (Thai)" value="nameThai" />
                                                <ExcelColumn label="Name (Japanese)" value="nameJapanese" />
                                                <ExcelColumn label="Name (Vietnamese)" value="nameVietnamese" />
                                                <ExcelColumn label="Description (English)" value="descriptionEnglish" />
                                                <ExcelColumn label="Description (Simplified Chinese)" value="descriptionSimplifiedChinese" />
                                                <ExcelColumn label="Description (Traditional Chinese)" value="descriptionTraditionalChinese" />
                                                <ExcelColumn label="Description (Thai)" value="descriptionThai" />
                                                <ExcelColumn label="Description (Japanese)" value="descriptionJapanese" />
                                                <ExcelColumn label="Description (Vietnamese)" value="descriptionVietnamese" />
                                            </ExcelSheet>
                                        </ExcelFile>
                                    }
                                </Col>
                            </Row>
                        </Card>

                        <Card style={{ marginTop: "2em" }}>
                            <Row className='importItemLanguage-row-container'>
                                <Col span={24} className='importItemLanguage-col-label'>
                                    <Text className='importItemLanguage-text-label'>Export Categories</Text><br />
                                </Col>
                                <Col span={24}>
                                    <Button onClick={() => this.exportCategoriesOnClick()} type="primary"><DownloadOutlined />Download</Button>
                                    {(!this.state.exportingCategories) ? '' :
                                        <ExcelFile filename="Categories" hideElement={true}>
                                            <ExcelSheet data={this.state.exportCategoriesDataSet} name="Categories">
                                                <ExcelColumn label="Slug Name" value="slugName" />
                                                <ExcelColumn label="Parent Slug Name" value="parentSlugName" />
                                                <ExcelColumn label="Is Sub Category" value="isSubCategory" />
                                                <ExcelColumn label="Total" value="total" />
                                                <ExcelColumn label="Request Limit" value="requestLimit" />
                                                <ExcelColumn label="Price" value="price" />
                                                <ExcelColumn label="Name (English)" value="nameEnglish" />
                                                <ExcelColumn label="Name (Simplified Chinese)" value="nameSimplifiedChinese" />
                                                <ExcelColumn label="Name (Traditional Chinese)" value="nameTraditionalChinese" />
                                                <ExcelColumn label="Name (Thai)" value="nameThai" />
                                                <ExcelColumn label="Name (Japanese)" value="nameJapanese" />
                                                <ExcelColumn label="Name (Vietnamese)" value="nameVietnamese" />
                                                <ExcelColumn label="Description (English)" value="descriptionEnglish" />
                                                <ExcelColumn label="Description (Simplified Chinese)" value="descriptionSimplifiedChinese" />
                                                <ExcelColumn label="Description (Traditional Chinese)" value="descriptionTraditionalChinese" />
                                                <ExcelColumn label="Description (Thai)" value="descriptionThai" />
                                                <ExcelColumn label="Description (Japanese)" value="descriptionJapanese" />
                                                <ExcelColumn label="Description (Vietnamese)" value="descriptionVietnamese" />
                                            </ExcelSheet>
                                        </ExcelFile>
                                    }
                                </Col>
                            </Row>
                        </Card>

                        <Card style={{ marginTop: "2em" }}>
                            <Row className='importItemLanguage-row-container'>
                                <Col span={24} className='importItemLanguage-col-label'>
                                    <Text className='importItemLanguage-text-label'>Export Sub Categories</Text><br />
                                </Col>
                                <Col span={24}>
                                    <Button onClick={() => this.exportSubCategoriesOnClick()} type="primary"><DownloadOutlined />Download</Button>
                                    {(!this.state.exportingSubCategories) ? '' :
                                        <ExcelFile filename="Sub Categories" hideElement={true}>
                                            <ExcelSheet data={this.state.exportSubCategoriesDataSet} name="Sub Categories">
                                                <ExcelColumn label="Slug Name" value="slugName" />
                                                <ExcelColumn label="Parent Slug Name" value="parentSlugName" />
                                                <ExcelColumn label="Is Sub Category" value="isSubCategory" />
                                                <ExcelColumn label="Total" value="total" />
                                                <ExcelColumn label="Request Limit" value="requestLimit" />
                                                <ExcelColumn label="Price" value="price" />
                                                <ExcelColumn label="Name (English)" value="nameEnglish" />
                                                <ExcelColumn label="Name (Simplified Chinese)" value="nameSimplifiedChinese" />
                                                <ExcelColumn label="Name (Traditional Chinese)" value="nameTraditionalChinese" />
                                                <ExcelColumn label="Name (Thai)" value="nameThai" />
                                                <ExcelColumn label="Name (Japanese)" value="nameJapanese" />
                                                <ExcelColumn label="Name (Vietnamese)" value="nameVietnamese" />
                                                <ExcelColumn label="Description (English)" value="descriptionEnglish" />
                                                <ExcelColumn label="Description (Simplified Chinese)" value="descriptionSimplifiedChinese" />
                                                <ExcelColumn label="Description (Traditional Chinese)" value="descriptionTraditionalChinese" />
                                                <ExcelColumn label="Description (Thai)" value="descriptionThai" />
                                                <ExcelColumn label="Description (Japanese)" value="descriptionJapanese" />
                                                <ExcelColumn label="Description (Vietnamese)" value="descriptionVietnamese" />
                                            </ExcelSheet>
                                        </ExcelFile>
                                    }
                                </Col>
                            </Row>
                        </Card>

                        <Card style={{ marginTop: "2em" }}>
                            <Row className='importItemLanguage-row-container'>
                                <Col span={24} className='importItemLanguage-col-label'>
                                    <Text className='importItemLanguage-text-label'>Export FNB</Text><br />
                                </Col>
                                <Col span={24}>
                                    <Button onClick={() => this.exportFnbOnClick()} type="primary"><DownloadOutlined />Download</Button>
                                    {(!this.state.exportingFnb) ? '' :
                                        <ExcelFile filename="FNB Items" hideElement={true}>
                                            <ExcelSheet data={this.state.exportFnbDataSet} name="FNB Items">
                                                <ExcelColumn label="Slug Name" value="slugName" />
                                                <ExcelColumn label="Parent Slug Name" value="parentSlugName" />
                                                <ExcelColumn label="Is Sub Category" value="isSubCategory" />
                                                <ExcelColumn label="Total" value="total" />
                                                <ExcelColumn label="Request Limit" value="requestLimit" />
                                                <ExcelColumn label="Price" value="price" />
                                                <ExcelColumn label="Name (English)" value="nameEnglish" />
                                                <ExcelColumn label="Name (Simplified Chinese)" value="nameSimplifiedChinese" />
                                                <ExcelColumn label="Name (Traditional Chinese)" value="nameTraditionalChinese" />
                                                <ExcelColumn label="Name (Thai)" value="nameThai" />
                                                <ExcelColumn label="Name (Japanese)" value="nameJapanese" />
                                                <ExcelColumn label="Name (Vietnamese)" value="nameVietnamese" />
                                                <ExcelColumn label="Description (English)" value="descriptionEnglish" />
                                                <ExcelColumn label="Description (Simplified Chinese)" value="descriptionSimplifiedChinese" />
                                                <ExcelColumn label="Description (Traditional Chinese)" value="descriptionTraditionalChinese" />
                                                <ExcelColumn label="Description (Thai)" value="descriptionThai" />
                                                <ExcelColumn label="Description (Japanese)" value="descriptionJapanese" />
                                                <ExcelColumn label="Description (Vietnamese)" value="descriptionVietnamese" />
                                            </ExcelSheet>
                                        </ExcelFile>
                                    }
                                </Col>
                            </Row>
                        </Card>

                        <Card style={{ marginTop: "2em" }}>
                            <Row className='importItemLanguage-row-container'>
                                <Col span={24} className='importItemLanguage-col-label'>
                                    <Text className='importItemLanguage-text-label'>Export Non FNB</Text><br />
                                </Col>
                                <Col span={24}>
                                    <Button onClick={() => this.exportNonFnbOnClick()} type="primary"><DownloadOutlined />Download</Button>
                                    {(!this.state.exportingNonFnb) ? '' :
                                        <ExcelFile filename="Non FNB Items" hideElement={true}>
                                            <ExcelSheet data={this.state.exportNonFnbDataSet} name="Non FNB Items">
                                                <ExcelColumn label="Slug Name" value="slugName" />
                                                <ExcelColumn label="Parent Slug Name" value="parentSlugName" />
                                                <ExcelColumn label="Is Sub Category" value="isSubCategory" />
                                                <ExcelColumn label="Total" value="total" />
                                                <ExcelColumn label="Request Limit" value="requestLimit" />
                                                <ExcelColumn label="Price" value="price" />
                                                <ExcelColumn label="Name (English)" value="nameEnglish" />
                                                <ExcelColumn label="Name (Simplified Chinese)" value="nameSimplifiedChinese" />
                                                <ExcelColumn label="Name (Traditional Chinese)" value="nameTraditionalChinese" />
                                                <ExcelColumn label="Name (Thai)" value="nameThai" />
                                                <ExcelColumn label="Name (Japanese)" value="nameJapanese" />
                                                <ExcelColumn label="Name (Vietnamese)" value="nameVietnamese" />
                                                <ExcelColumn label="Description (English)" value="descriptionEnglish" />
                                                <ExcelColumn label="Description (Simplified Chinese)" value="descriptionSimplifiedChinese" />
                                                <ExcelColumn label="Description (Traditional Chinese)" value="descriptionTraditionalChinese" />
                                                <ExcelColumn label="Description (Thai)" value="descriptionThai" />
                                                <ExcelColumn label="Description (Japanese)" value="descriptionJapanese" />
                                                <ExcelColumn label="Description (Vietnamese)" value="descriptionVietnamese" />
                                            </ExcelSheet>
                                        </ExcelFile>
                                    }
                                </Col>
                            </Row>
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default ImportItemLanguagePage;